import { PopularCategory } from '@app/entities/categories/interfaces/popular-category';
import { SearchRequest } from '@app/entities/search-requests/interfaces/search-request';
import { Selector } from '@ngxs/store';
import { MainpageStateModel } from './mainpage-state.model';
import { MainpageState } from './mainpage.state';

export class MainpageSelectors {
  @Selector([MainpageState])
  static latestSearchRequests(
    state: MainpageStateModel,
  ): SearchRequest[] | undefined {
    return state.latestSearchRequests;
  }

  @Selector([MainpageState])
  static trendingSearchRequests(
    state: MainpageStateModel,
  ): string[] | undefined {
    return state.trendingSearchRequests;
  }

  @Selector([MainpageState])
  static popularCategories(
    state: MainpageStateModel,
  ): PopularCategory[] | undefined {
    return state.popularCategories;
  }

  @Selector([MainpageState])
  static popularSearchRequests(
    state: MainpageStateModel,
  ): string[] | undefined {
    return state.popularSearchRequests;
  }
}
